import { render, staticRenderFns } from "./admin-email-chart.vue?vue&type=template&id=9d064e66&"
import script from "./admin-email-chart.vue?vue&type=script&lang=js&"
export * from "./admin-email-chart.vue?vue&type=script&lang=js&"
import style0 from "./admin-email-chart.vue?vue&type=style&index=0&id=9d064e66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports